import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

axios.defaults.withCredentials = true;

// Basename dinamico: funziona sia in locale (/kleos-dashboard) sia live (/)
const rawBase =
  process.env.REACT_APP_BASENAME ||
  process.env.PUBLIC_URL ||
  '';

// Se è un URL assoluto, estrai solo il path; se è '.', usa vuoto; togli trailing slash
const fromUrl = rawBase.replace(/^https?:\/\/[^/]+/i, '');
const normalized = (fromUrl === '.' ? '' : fromUrl).replace(/\/+$/, '');

// Auto-deduzione in dev locale se non è settato nulla
const autoBase =
  normalized ||
  (typeof window !== 'undefined' &&
   window.location &&
   window.location.pathname.startsWith('/kleos-dashboard')
     ? '/kleos-dashboard'
     : '');

if (process.env.NODE_ENV !== 'production') {
  // Utile per debug in locale
  // eslint-disable-next-line no-console
  console.log('[Router] basename =', autoBase || '(root)');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter basename={autoBase}>
          <App />
      </BrowserRouter>
  </React.StrictMode>
);
